import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchCalculationLogBatches = createAsyncThunk("fetchCalculationLogBatches", async ({ page, limit, filters }) => {
    const params = new URLSearchParams({
        page: page || 1,
        limit: limit || 20,
        distributorCode: filters?.distributorCode || "",
    });

    const response = await axiosHttp.get(`replenishment-suggestions/log-batches?${params}`);
    return response.data;
});

export const fetchCalculationLogsDetail = createAsyncThunk("fetchCalculationLogsDetail", async ({ batchUuid, page, limit, filters }) => {
    const params = new URLSearchParams({
        batchUuid,
        page: page || 1,
        limit: limit || 50,
        productId: filters?.productId || "",
    });

    const response = await axiosHttp.get(`replenishment-suggestions/logs?${params}`);
    return response.data;
});

const CalculationLogsSlice = createSlice({
    name: "CalculationLogsSlice",
    initialState: {
        batchesLoading: false,
        batchesData: [],
        batchesTotal: 0,
        batchesPage: 1,

        detailLoading: false,
        detailData: [],
        detailTotal: 0,
        detailPage: 1,

        error: null,
    },

    extraReducers: (builder) => {
        // Batches
        builder.addCase(fetchCalculationLogBatches.pending, (state) => {
            state.batchesLoading = true;
        });
        builder.addCase(fetchCalculationLogBatches.fulfilled, (state, action) => {
            state.batchesLoading = false;
            const payload = action.payload;
            const rawData = payload?.data;
            const arg = action.meta.arg;
            state.batchesData = Array.isArray(rawData?.batches) ? rawData.batches : (Array.isArray(rawData?.data) ? rawData.data : (Array.isArray(rawData) ? rawData : []));

            const total = rawData?.totalDocs || rawData?.total || payload?.pagination?.totalRecords || payload?.total || rawData?.count;
            if (total !== undefined) state.batchesTotal = total;

            state.batchesPage = rawData?.page || payload?.pagination?.currentPage || (rawData?.offset !== undefined ? Math.floor(rawData.offset / (rawData.limit || 20)) + 1 : arg.page || 1);
        });
        builder.addCase(fetchCalculationLogBatches.rejected, (state, action) => {
            state.batchesLoading = false;
            state.error = action.error?.message;
        });

        // Detail
        builder.addCase(fetchCalculationLogsDetail.pending, (state) => {
            state.detailLoading = true;
        });
        builder.addCase(fetchCalculationLogsDetail.fulfilled, (state, action) => {
            state.detailLoading = false;
            const payload = action.payload;
            const rawData = payload?.data;
            const arg = action.meta.arg;
            state.detailData = Array.isArray(rawData?.logs) ? rawData.logs : (Array.isArray(rawData?.data) ? rawData.data : (Array.isArray(rawData) ? rawData : []));

            const total = rawData?.totalDocs || rawData?.total || payload?.pagination?.totalRecords || payload?.total || rawData?.count;
            if (total !== undefined) state.detailTotal = total;

            state.detailPage = rawData?.page || payload?.pagination?.currentPage || (rawData?.offset !== undefined ? Math.floor(rawData.offset / (rawData.limit || 50)) + 1 : arg.page || 1);
        });
        builder.addCase(fetchCalculationLogsDetail.rejected, (state, action) => {
            state.detailLoading = false;
            state.error = action.error?.message;
        });
    },
});

export default CalculationLogsSlice.reducer;
